import React, { Fragment, memo, useCallback } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Icon, NakedButton, Flex, Text } from 'roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';
import PageBlock from 'components/PageBlock';

const BackButton = styled(NakedButton)`
  color: ${themeGet('colors.white')};
  width: 100%;
  display: flex;
`;

const BackToPropertyLink = () => {
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Change Your Selection', value: 'Link Clicked' });
    window.history.back();
  }, [emitInteractionEvent]);

  return (
    <Fragment>
      <PageBlock display={['none', 'block']} py={4} printable={false} data-testid="desktop-page-block">
        <NakedButton
          color="greys.steel"
          hoverColor="ui.linkHover"
          onClick={handleOnClick}
          data-testid="property-back-link"
          aria-label="Change your property selection"
        >
          <Flex verticalAlign="center">
            <Icon name="chevronLeft" color="greys.steel" size={24} mr={2} data-testid="desktop-back-button-icon" />
            Change your selection
          </Flex>
        </NakedButton>
      </PageBlock>
      <PageBlock display={['block', 'none']} py={4} backgroundColor="greys.charcoal" printable={false} data-testid="mobile-page-block">
        <BackButton aria-label="Change your property selection" onClick={handleOnClick} data-testid="mobile-back-button">
          <Icon name="chevronLeft" size={24} />
          <Text mx="auto" pr={9}>
            Review & pay
          </Text>
        </BackButton>
      </PageBlock>
    </Fragment>
  );
};

export default memo(BackToPropertyLink);
